import { useQuery } from "@tanstack/react-query";
import * as React from "react";
import { HelmetDexteel } from "../../../helmet/HelmetDexteel";
import { TableUsers } from "./components/UsersDataTable/TableUsers";
import { User } from "./models/User";
import { getDataUser, getUsers } from "./repositories/UsersRepository";

export const searchUsers = () => {
	return useQuery<User[], Error>({
		queryKey: ["users"],
		queryFn: ({ signal }) => getUsers(signal),
	});
};

export const searchUser = ({ userId }: { userId: number | null }) => {
	return useQuery<User[], Error>({
		queryKey: ["user", userId],
		queryFn: ({ signal }) => getDataUser({ userId: userId as number }, signal),
		enabled: !!userId,
	});
};

export const Users = () => {
	return (
		<>
			<HelmetDexteel title="Users Management" />
			<TableUsers />
		</>
	);
};
